<template>
  <div>
    <page-header has-return :page="pageHeaderConfig" />
    <div class="row">
      <div class="col-12">
        <filter-manager
          ref="filterRef"
          :filters="filtersConfig"
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync pr-2"
          search-text=""
          search-container-class="btn-process-custom d-flex align-items-center justify-content-end"
          v-model="filterModel"
          @search="onProcessHandler"
        >
          <div class="col d-flex justify-content-end align-items-center">
            <dropdown
              icon="fas fa-print"
              :items="reportOptions"
              title="Seleccione"
            />
          </div>
        </filter-manager>
      </div>
    </div>
  </div>
</template>

<script>
//libs components
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import Dropdown from 'dropdown'

//services
import AcademicYearServices from '@/services/api/academicyear.api'
import RpServices from '@/services/api/rp.api.js'
import CodeServices from '@/services/api/code.api.js'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js'

//constants
import codeAcademicYear from '@/utils/constants/codeAcademicYear.js'

export default {
  name: 'ContractsByProvider',
  components: {
    PageHeader,
    FilterManager,
    Dropdown,
  },
  mixins: [alertMixin],
  data: () => ({
    filterOptions: {
      academicYears: [],
      contractStatuses: [],
      providers: [],
      specialists: [],
      disciplines: [],
    },
    filterModel: {
      academicYear: null,
      contractStatus: null,
      provider: null,
      specialist: null,
      discipline: null,
    },
  }),
  computed: {
    pageHeaderConfig() {
      return {
        icon: 'fas fa-chart-pie',
        title: 'Informe de Contratos por Corporación',
        routes: ['Inicio', 'Reportes', 'Informe de Contratos por Corporación'],
      }
    },
    filtersConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Año Académico',
          error: 'El año académico es requerido.',
          validations: 'required',
          clearable: false,
          class: 'col-12 col-md-4',
          options: this.filterOptions.academicYears,
          value: this.filterModel.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'provider',
          component: 'custom-drop-down',
          class: 'col-12 col-md-4',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Proveedor',
          error: 'El proveedor es requerido.',
          validations: 'required',
          options: this.filterOptions.providers,
          onChanged: this.onChangeProvider,
          disabled: this.disabledFilterByProvider,
        },
        {
          name: 'specialist',
          component: 'custom-drop-down',
          class: 'col-12 col-md-4',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Especialista',
          options: this.filterOptions.specialists,
        },
        {
          name: 'contractStatuses',
          component: 'custom-drop-down',
          class: 'col-12 col-md-4',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Estatus del Contrato',
          options: this.filterOptions.contractStatuses,
        },
        {
          name: 'discipline',
          component: 'custom-drop-down',
          class: 'col-12 col-md-4',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Disciplina',
          clearable: true,
          options: this.filterOptions.disciplines,
        },
      ]
    },
    reportOptions() {
      return [
        {
          label: 'Excel',
          icon: 'fas fa-print text-green',
          class: 'pr-1',
          visible: true,
          click: () => this.onProcessHandler(false),
        },
        {
          label: 'PDF',
          icon: 'fas fa-print text-green',
          class: 'pr-1',
          visible: true,
          click: () => this.onProcessHandler(true),
        },
      ]
    },
    userHasSingleCompany() {
      return this.userCompanies?.length === 1
    },
    userCurrentCompany() {
      return this.userHasSingleCompany ? this.userCompanies[0] : null
    },
    disabledFilterByProvider() {
      return this.userHasSingleCompany && !!this.filterModel.provider?.id
    },
  },
  async mounted() {
    await this.getInitialFilters()
  },
  methods: {
    async getInitialFilters() {
      this.filterOptions.academicYears = (
        await AcademicYearServices.getAcademicYearsFromSpecificYear(
          codeAcademicYear['2016-2017']
        )
      ).data

      this.filterOptions.contractStatuses = (
        await RpServices.getContractStatuses()
      ).data

      this.filterOptions.disciplines = (
        await CodeServices.getAllRpDisciplineTypes()
      ).data
    },
    async onChangeAcademicYear() {
      this.filterModel.provider = null
      this.filterModel.specialist = null
      this.filterOptions.providers = []
      this.filterOptions.specialists = []

      await this.GetProvidersInAcademicYear()

      if (this.userHasSingleCompany) {
        this.filterModel.specialist = null
        this.filterOptions.specialists = []
        await this.GetSpecialistInAcademicYearAndProvider()
      }
    },
    async onChangeProvider() {
      this.filterModel.specialist = null
      this.filterOptions.specialists = []

      await this.GetSpecialistInAcademicYearAndProvider()
    },
    async GetProvidersInAcademicYear() {
      this.filterOptions.providers = (
        await RpServices.getProviders(this.filterModel.academicYear.id)
      ).data
      this.filterModel = {
        ...this.filterModel,
        provider: this.userCurrentCompany,
      }
    },
    async GetSpecialistInAcademicYearAndProvider() {
      this.filterOptions.specialists = (
        await RpServices.getSpecialists(
          this.filterModel.academicYear.id,
          this.filterModel.provider.id
        )
      ).data
    },
    async getSpecialists() {
      this.filterOptions.specialists = (
        await RpServices.getSpecialists(this.filterModel.academicYear.id)
      ).data
    },
    async onProcessHandler(isPdfFormat) {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        )
        return
      }

      await ReportServices.getReport('rpcontractsbyprovider', {
        academicYearId: this.filterModel.academicYear.id,
        companyId: this.filterModel.provider?.id,
        specialistId: this.filterModel.specialist?.id,
        contractStatusId: this.filterModel.contractStatuses?.id,
        disciplineTypeId: this.filterModel.discipline?.id,
        isPdfFormat,
      }).then((res) => DocumentServices.Download(res.data))
    },
  },
}
</script>

<style scope>
.btn-process-custom {
  position: absolute !important;
  bottom: 17px !important;
  right: 15px !important;
}
</style>
